import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    // Handle must change password forced flow
    if (error.response?.status === 403) {
      const detail = error.response?.data?.detail;
      const code = typeof detail === "object" ? detail?.code : null;
      if (code === "MUST_CHANGE_PASSWORD" && window.location.pathname !== "/cambiar-password") {
        localStorage.setItem("must_change_password", "true");
        window.location.href = "/cambiar-password";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
